import { ReviewButtons } from './ReviewButtons';
import { ContentActionRoot } from './Root';
import { FavoriteButton } from './FavoriteButton';
import { ContentReport } from './ContentReport';

export const ContentActions = {
  Root: ContentActionRoot,
  ReviewButtons: ReviewButtons,
  FavoriteButton: FavoriteButton,
  Report: ContentReport,
};
